// extracted by mini-css-extract-plugin
export default {"wrapper":"qy-z","viewport":"ry-z","container":"sy-z","slide":"ty-z"};